<template>
  <v-dialog
    :value="value"
    transition="slide-y-transition"
    max-width="50rem"
    @input="val => $emit('input', val)">
    <v-card>
      <v-card-text>
        <v-container>
          <v-layout>
            <v-card flat>
              <v-card-text>
                <v-date-picker
                  ref="picker"
                  v-model="dt"
                  full-width
                  landscape
                  class="mb-1"/>
                <v-time-picker
                  ref="picker"
                  v-model="tm"
                  full-width
                  landscape/>
              </v-card-text>
            </v-card>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          flat
          @click="$emit('input', false)">
          Cancel
        </v-btn>
        <v-btn
          flat
          @click="close">
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/*
 * Displays the date in a readable format
 * moment has many formatting options, see:
 * https://momentjs.com/docs/#/displaying
 */
import moment from "moment";

export default {
  name: "picker-dialog",
  props: {
    value: {
      required: true,
      type: Boolean
    },
    dateIso: {
      required: true,
      validator: (val) => val === null || typeof val === "string"
    }
  },
  data () {
    return {
      dt: null,
      tm: null
    };
  },
  watch: {
    value (open) {
      if (open) {
        const dateObj = this.isoToObject(this.dateIso);
        this.dt = dateObj.date;
        this.tm = dateObj.time;
      }
    }
  },
  methods: {
    close () {
      this.$emit("input", false);
      this.$emit("update:dateIso", this.objectToIso({
        date: this.dt,
        time: this.tm
      }));
    },
    objectToIso (obj) {
      if (!obj.date || !obj.time) {
        return null;
      }
      return moment().
        year(parseInt(obj.date.substring(0, 4), 10)).
        month(parseInt(obj.date.substring(5, 7), 10) - 1).
        date(parseInt(obj.date.substring(8, 10), 10)).
        hours(parseInt(obj.time.substring(0, 2), 10)).
        minutes(parseInt(obj.time.substring(3, 5), 10)).
        toISOString();
    },
    isoToObject (iso) {
      if (!iso) {
        return {
          time: null,
          date: null
        };
      }
      return {
        time: moment(iso).format("HH:mm"),
        date: moment(iso).format("YYYY-MM-DD")
      };
    }
  }
};
</script>

<style scoped>
.v-card.v-picker {
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/components/SharedComponents/PickerDialog.vue